export default __webpack_public_path__ + "static/media/affligem_m1.32d06643.png";